"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconOrders = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconOrders = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsx)("path", { fill: "#464650", fillRule: "evenodd", d: "M7 14v-1h4v1zm0 2v-1h4v1zm12.853-6.236 2.803-1.4-3.29-3.292-1.85.616 2.27 3.921c.028.047.043.104.067.155M18.623 21c.207 0 .377-.198.377-.442V11H5v9.558c0 .244.17.442.378.442zM4.634 5.072l-3.29 3.291 2.803 1.401c.026-.055.042-.116.075-.168L6.485 5.69zm19.218 3.074a.5.5 0 0 1-.129.801L20 10.81v9.75c0 .794-.618 1.441-1.378 1.441H5.378C4.618 22 4 21.353 4 20.558V10.81L.276 8.947a.502.502 0 0 1-.13-.8l4-4a.5.5 0 0 1 .512-.12l2.945.981c.02 0 .038-.008.058-.008h1.84a.5.5 0 1 1 0 1H7.66a.37.37 0 0 0-.307.183L5.144 10h13.712l-2.218-3.83A.36.36 0 0 0 16.34 6H14.5a.5.5 0 0 1 0-1h1.84c.02 0 .037.007.057.007l2.945-.98a.5.5 0 0 1 .511.12zm-12.13.77-1.5-1a.5.5 0 1 1 .555-.832l.737.492c-.003-.026-.015-.049-.015-.076v-5a.5.5 0 0 1 1 0v5c0 .027-.011.05-.015.076l.738-.492a.5.5 0 0 1 .693.139c.154.23.092.54-.138.693l-1.5 1a.5.5 0 0 1-.555 0" })] })));
};
exports.IconOrders = IconOrders;
exports.IconOrders.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconOrders;
